<template>
  <div class="content-popup">
    <vs-row class="content-popup pb-5 mb-5">

      <div class="content-internal px-0 mb-5 pt-3">

        <h2 style="font-size:20px; text-transform: uppercase;">Términos de uso</h2>
      <p>
        {{genderuppercase}} <strong>{{ terms.hashtag }}</strong> es una iniciativa d{{genderlowercase}}
        <strong>{{ terms.clientName }}</strong> persona jurídica
        <span v-if="containClientCity"> con domicilio en la ciudad de {{ terms.clientCity }}</span>
        <span v-else-if="containClientAddress"> con domicilio en {{ terms.clientAddress }},</span>
        inscrita con el {{ clientDocumentLabel }} nº {{ terms.clientCNPJ }} (“{{ terms.clientNickname }}”) y de
        <strong>FANBASE NETWORK TECNOLOGIA E SERVIÇOS S.A.</strong>, persona jurídica
        con domicilio en la ciudad de Campinas- SP, inscrita en el CNPJ con el nº
        41.835.006/0001-66 ("FANBASE"), en adelante {{ terms.clientNickname }} y FANBASE conjuntamente
        (“PARTES”).
      </p>
        <p>
          {{genderuppercase}} <strong>{{ terms.hashtag }}</strong> ofrece al Usuario un entorno digital
          que permite completar un registro y responder a distintas preguntas, con el fin de
          estrechar la relación con las PARTES y sus socios comerciales. De este
          modo, los presentes Términos de Uso ("Términos") tienen por objeto regular el uso que
          usted (en adelante, "Usuario") hace de las Páginas <strong>{{ terms.hashtag }}.</strong>
        </p>
        <p>
          Estos Términos están disponibles para su consulta en cualquier momento por parte del
          Usuario, mediante la dirección
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >. Además, se aplican a los presentes Términos y al uso de las Páginas
          lo dispuesto en la Política de Privacidad de <strong>{{ terms.hashtag }}</strong>,
          disponible en
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >.
        </p>
        <p>
          Además, los presentes Términos podrán actualizarse, en cualquier momento, mediante aviso
          en el sitio y/o por correo electrónico, si el Usuario ha optado por recibir comunicaciones
          de las PARTES.
        </p>
        <h3>1. CONDICIONES DE ACCESO Y USO DE LAS PÁGINAS</h3>
        <h4>1.1 Carácter gratuito del acceso y del uso de las Páginas</h4>
        <p>
          El acceso y el uso de las Páginas por parte del Usuario tienen, como regla,
          carácter gratuito.
        </p>
        <h4>1.2 Registro del Usuario para la participación en {{ terms.hashtag }}</h4>
        <p>
          De conformidad con lo establecido en el reglamento <strong>{{ terms.hashtag }}</strong>,
          para poder participar en la investigación a partir del sitio
          <strong>{{ terms.hashtag }}</strong>, el Usuario deberá registrarse mediante
          el llenado del formulario disponible a través del enlace:
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >, mediante la provisión de información auténtica y veraz.
        </p>
        <p>
          Después de completar el registro y la aceptación de los presentes Términos, el Usuario podrá continuar con el
          llenado y estará habilitado para participar en las posibles premiaciones que se pondrán a disposición mediante
          la plataforma, las cuales se llevarán a cabo conforme al reglamento publicado en
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >
        </p>
        <p>
          En las fechas establecidas en el Reglamento, los ganadores serán notificados sobre el
          resultado y la forma de recibir la premiación, cuando corresponda.
        </p>
        <p>
          Toda la información facilitada por el Usuario a través de las Páginas deberá ser
          veraz. Por ello, el Usuario garantiza la autenticidad de todos los datos que
          informe durante el completado de los formularios correspondientes. De este modo,
          el Usuario podrá ejercer su derecho de corrección de datos incompletos,
          inexactos o desactualizados, con el fin de mantener toda la información proporcionada a
          <strong>{{ terms.hashtag }}</strong> permanentemente actualizada, de modo que
          refleje siempre los datos reales del Usuario.
        </p>
        <p>
          En cualquier circunstancia, el Usuario será el único responsable de las declaraciones
          falsas o inexactas que proporcione y que puedan causar perjuicios a las PARTES, a
          terceros o a sí mismo, como por ejemplo, en el caso de cancelación de
          premiaciones por disponer de datos incorrectos o incompletos.
        </p>
        <p>
          Para mayor información sobre el tratamiento de los datos personales recogidos para
          esta finalidad, consulte la Política de Privacidad de {{ terms.hashtag }},
          disponible en
          <a :href="terms.url" target="_blank"
          >{{ terms.url }}</a
          >
          .
        </p>
        <h4>1.3 Obligación de utilizar las Páginas correctamente</h4>
<p>
  Al utilizar las Páginas {{pronoun}} <strong>{{ terms.hashtag }}</strong>, el Usuario se compromete a respetar la legislación brasileña vigente, así como todo lo dispuesto en los presentes Términos, no debiendo producir, disponibilizar, divulgar o transmitir cualquier contenido que:
</p>
<p>
  <strong>a)</strong> Sea contrario a cualquier norma de la legislación brasileña, así como a la moral y a las buenas costumbres generalmente aceptadas;
</p>
<p>
  <strong>b)</strong> Incentive la discriminación, el odio o la violencia contra personas o grupos por razón de orientación sexual, género, raza, religión, discapacidad, nacionalidad o por cualquier otro motivo;
</p>
<p>
  <strong>c)</strong> Incorpore, ponga a disposición o permita acceder a productos, elementos, mensajes y/o servicios ilegales, violentos, pornográficos, degradantes o, en general, contrarios a la ley, a la moral y a las buenas costumbres generalmente aceptadas o al orden público;
</p>
<p>
  <strong>d)</strong> Sea falso, ambiguo, inexacto, exagerado o extemporáneo, de forma que pueda inducir a error sobre su objeto o sobre las intenciones o propósitos {{pronoun}} comunicante;
</p>
<p>
  <strong>e)</strong> Esté protegido por cualesquiera derechos de propiedad intelectual o industrial pertenecientes a terceros, sin que el Usuario haya obtenido previamente de sus titulares la autorización necesaria para llevar a cabo el uso que efectúe o pretenda efectuar;
</p>
<p>
  <strong>f)</strong> Incorpore virus u otros elementos físicos o electrónicos que puedan causar daño o impedir el normal funcionamiento de la red, del sistema o de equipos informáticos ("hardware" y "software") de terceros, o que puedan causar daño a los documentos electrónicos y archivos almacenados en estos equipos informáticos; o,
</p>
<p>
  <strong>g)</strong> Provoque, por sus características (tales como forma, extensión, etc.), dificultades en el normal funcionamiento del Servicio.
</p>
<p>
  En cualquier circunstancia, el Usuario es el único responsable por el uso que haga de las Páginas de {{ terms.hashtag }}, así como por cualquier contenido por él insertado.
</p>

<h4>1.5 Utilización Correcta del Contenido y Propiedad Intelectual</h4>
<p>
  El Usuario se compromete a utilizar las Páginas y su contenido, es decir, los textos, gráficos, iconos, enlaces, fotografías, imágenes, tecnología y demás contenidos audiovisuales o sonoros, software, diseños gráficos y códigos fuente (en conjunto, "Contenido(s)"), de acuerdo con todo el ordenamiento jurídico, con la moral y las buenas costumbres generalmente aceptadas, con los presentes Términos y con las Condiciones Particulares de cada Página.
</p>
<p>
  Todas las marcas, nombres comerciales o logotipos de cualquier tipo disponibilizados en las Páginas son propiedad de las PARTES, sin que la utilización de las Páginas pueda entenderse como autorización para que el Usuario pueda citar tales marcas, nombres comerciales y/o logotipos.
</p>
<p>
  Todo el Contenido es propiedad exclusiva de las PARTES, o de terceros que autorizaron su utilización en las Páginas, y está protegido por leyes y tratados internacionales, estando prohibida su copia, reproducción o cualquier otro tipo de utilización, quedando los infractores sujetos a las sanciones civiles y penales correspondientes, en los términos de las Leyes 9.610/98, 9.609/98 y 9.279/96.
</p>
<p>
  El Usuario deberá abstenerse de obtener, o de intentar obtener, los Contenidos por medios distintos de aquellos que, en cada caso, hayan sido puestos a disposición para tales propósitos.
</p>

<h4>1.6 Política Anti-Spam</h4>
<p>Por medio de este documento las PARTES se obligan a abstenerse de:</p>
<p>
  <strong>a)</strong> obtener datos con finalidad publicitaria y remitir publicidad de cualquier clase con finalidad de venta u otras de naturaleza comercial sin la previa solicitud y consentimiento;
</p>
<p>
  <strong>b)</strong> remitir a un grupo de personas cualesquiera mensajes no solicitados ni previamente consentidos;
</p>
<p>
  <strong>c)</strong> enviar cadenas de mensajes electrónicos no solicitados ni previamente consentidos;
</p>
<p>
  <strong>d)</strong> utilizar listas de distribución a las que se pueda tener acceso a través de las Páginas para la realización de las actividades descritas en los ítems anteriores; y
</p>
<p>
  <strong>e)</strong> poner a disposición de terceros, con cualquier finalidad, datos captados a partir de listas de distribución.
</p>
<p>
  El Usuario o terceros perjudicados por la recepción de mensajes no solicitados, relacionados con las Páginas y dirigidos a una pluralidad de personas, podrán efectuar su reclamación comunicando a las PARTES por medio del sitio
  <a :href="terms.url" target="_blank">{{ terms.url }}</a>
</p>

<h4>
  1.7 Introducción de "hiperlinks" que permitan el acceso a las Páginas de {{ terms.hashtag }}
</h4>
<p>
  El Usuario que se proponga establecer un hipervínculo entre su página web y las Páginas {{pronoun}} {{ terms.hashtag }} ("Hiperlink") deberá cumplir las siguientes condiciones:
</p>
<p>
  <strong>a)</strong> el "Hiperlink" permitirá única y exclusivamente el acceso a la homepage o página de inicio de las Páginas, pero no podrá reproducirla de ninguna forma;
</p>
<p>
  <strong>b)</strong> no realizar manifestaciones o indicaciones falsas, inexactas o incorrectas sobre las PARTES, sus administradores, empleados o Páginas;
</p>
<p>
  <strong>c)</strong> no declarar ni dar a entender que las PARTES habrían autorizado el "Hiperlink" o que habrían supervisado o asumido, de cualquier forma, responsabilidad sobre los servicios ofrecidos o puestos a disposición en la página web en la que se establezca el "Hiperlink";
</p>
<p>
  <strong>d)</strong> con excepción de los signos que formen parte del "Hiperlink", la página web en la que se establezca el "Hiperlink" no contendrá ninguna marca, nombre comercial, logotipo, eslogan, "look and feel" u otros signos pertenecientes a las PARTES;
</p>
<p>
  <strong>e)</strong> la página web en la que se establezca el "Hiperlink" no deberá contener informaciones o contenidos ilícitos, contrarios a la moral, a las buenas costumbres o al orden público, así como tampoco contenidos contrarios a los derechos de terceros.
</p>
<p>
  La inclusión de un "Hiperlink" no implica, en ningún caso, la existencia de relaciones entre las PARTES y el propietario de la página web que lo contenga, ni la aceptación o aprobación de las PARTES respecto de sus contenidos o servicios.
</p>

<h3>2. DURACIÓN Y FINALIZACIÓN</h3>
<p>
  El acceso a las Páginas {{pronoun}} {{ terms.hashtag }} se concede al Usuario por plazo
  indefinido. No obstante, las PARTES están facultadas para dar por terminado,
  suspender o interrumpir unilateralmente, en cualquier momento y sin necesidad
  de previo aviso, el acceso a las Páginas, sin que se deba ninguna indemnización
  al Usuario.
</p>
<p>
  Asimismo, las PARTES se reservan el derecho de rechazar o retirar el acceso a las
  Páginas, en cualquier momento y sin necesidad de previo aviso, por iniciativa
  propia o por exigencia de un tercero, a aquellos Usuarios que incumplan
  estos Términos.
</p>

<h3>3. EXCLUSIÓN DE GARANTÍAS Y DE RESPONSABILIDAD</h3>
<p>
  Como consecuencia de cuestiones técnicas y operativas, las PARTES no pueden
  garantizar la disponibilidad, infalibilidad y continuidad del funcionamiento de las
  Páginas, ni garantizan la utilidad de las Páginas para la realización de cualquier
  actividad concreta. En consecuencia, las PARTES no serán, en ningún caso,
  responsables por cualesquiera daños derivados de la interrupción del acceso a las
  Páginas, ni por fallos en su funcionamiento, ni se responsabilizan por la falta de
  utilidad que los Usuarios puedan haber atribuido a las Páginas, por su
  falibilidad, ni por cualquier dificultad de acceso.
</p>
<p>
  Las PARTES utilizan las mejores prácticas recomendadas del mercado para mantener
  seguros todos los datos introducidos por el Usuario en las Páginas; sin embargo, no
  garantizan que terceros no autorizados no utilicen medios ilícitos para obtener
  indebidamente dicha información. En consecuencia, las PARTES se eximen de
  responsabilidad por los daños y perjuicios de toda naturaleza que puedan derivarse
  del conocimiento que terceros no autorizados puedan tener de cualquier información
  proporcionada, como resultado de fallos atribuibles exclusivamente a los Usuarios o
  a terceros fuera de cualquier control razonable de las PARTES.
</p>
<p>
  Las PARTES no garantizan la ausencia de virus en las Páginas, ni de otros
  elementos nocivos que puedan producir alteraciones en los sistemas informáticos de
  los Usuarios (software y hardware) o en los documentos electrónicos almacenados en
  dichos sistemas, eximiéndose de cualquier responsabilidad por los daños y perjuicios
  que puedan derivarse de tales elementos.
</p>
<p>
  Las PARTES no verifican ni controlan el uso que el Usuario hace de las Páginas.
  En consecuencia, se eximen de cualquier responsabilidad por los daños y perjuicios
  de toda naturaleza que puedan derivarse de la utilización de las Páginas o que
  puedan deberse a la falta de veracidad, vigencia, exhaustividad y/o autenticidad del
  contenido allí disponibilizado, así como de la información que los Usuarios
  proporcionan a otros Usuarios sobre sí mismos y, en particular, aunque no de forma
  exclusiva, por los daños y perjuicios de toda naturaleza que puedan deberse a la
  suplantación de identidad realizada por un Usuario en cualquier tipo de
  comunicación llevada a cabo a través de las Páginas.
</p>

<h3>4. PROCEDIMIENTO EN CASO DE REALIZACIÓN DE ACTIVIDADES DE CARÁCTER ILÍCITO</h3>
<p>
  En el caso de que un Usuario o un tercero considere que existen informaciones,
  hechos o circunstancias que constituyen una actividad ilícita en las Páginas de
  las PARTES, especialmente en caso de violación de derechos de propiedad
  intelectual u otros derechos, deberá enviar una comunicación a las PARTES que
  contenga los siguientes datos:
</p>
<p>
  <strong>a)</strong> datos personales: nombre, dirección, número de teléfono y
  dirección de correo electrónico del reclamante;
</p>
<p>
  <strong>b)</strong> especificación de la supuesta actividad ilícita ocurrida en las
  Páginas y, en particular, cuando se trate de una supuesta violación de derechos de
  autor, indicación precisa y completa de los contenidos protegidos y
  supuestamente infringidos;
</p>
<p>
  <strong>c)</strong> hechos o circunstancias que revelen el carácter ilícito de
  dicha actividad; y
</p>
<p>
  <strong>d)</strong> en su caso, declaración expresa y clara de que la utilización de
  los contenidos se realizó sin el consentimiento del titular de los derechos de
  propiedad intelectual supuestamente infringidos.
</p>
<p>
  Siempre de acuerdo con la legislación vigente, a partir del conocimiento de los
  hechos, las PARTES podrán eliminar el contenido denunciado como ilícito, así como
  proporcionar información a las autoridades competentes, mediante el correspondiente
  requerimiento, con el fin de posibilitar la investigación de conductas ilegales.
</p>

<h3>5. DISPOSICIONES GENERALES</h3>
<p>
  Si cualquier parte de estos Términos fuera considerada inválida o inaplicable, dicho
  apartado deberá interpretarse de forma coherente con la legislación aplicable, para
  reflejar, en la medida de lo posible, la intención original de las partes, y las
  demás disposiciones permanecerán en pleno vigor y efecto.
</p>
<p>
  El hecho de que las PARTES no exijan el cumplimiento de cualesquiera derechos o
  disposiciones de los presentes Términos no constituirá una renuncia, pudiendo ejercer
  dichos derechos regularmente dentro de los plazos legales.
</p>

<h3>6. NOTIFICACIONES</h3>
<p>
  Todas las notificaciones y comunicaciones (en adelante, las "Notificaciones") por parte
  del Usuario a las PARTES deberán realizarse a través del canal “Contáctanos” del
  sitio
  <a :href="terms.url" target="_blank">{{ terms.url }}</a>.
</p>
<p>
  Todas las notificaciones y comunicaciones (en adelante, las "Notificaciones") por parte
  de las PARTES al Usuario se considerarán eficaces, para todos los efectos,
  cuando se realicen de alguna de las siguientes formas:
</p>
<p>
  <strong>a)</strong> envío de carta al domicilio del Usuario cuando este haya
  proporcionado una dirección válida a las PARTES.
</p>
<p>
  <strong>b)</strong> envío de mensaje por correo electrónico a cualquiera de las
  direcciones proporcionadas por el Usuario; y
</p>
<p>
  <strong>c)</strong> comunicación telefónica al número proporcionado por el Usuario,
  como por SMS y/o por WhatsApp;
</p>
<p>
  En este sentido, todas las Notificaciones que las PARTES realicen se considerarán
  válidas cuando se efectúen utilizando los datos y a través de los medios
  anteriormente indicados. Para estos efectos, el Usuario declara que todos los
  datos proporcionados son válidos y correctos, comprometiéndose a comunicar a
  las PARTES cualquier cambio relativo a los datos de notificación.
</p>

<hr style="margin: 50px 0px 100px 0px; border-top: 2px solid var(--second-color);">

<h2 style="font-size:20px; text-transform: uppercase;">POLÍTICA DE PRIVACIDAD</h2>
<p>
  {{genderuppercase}} <strong>{{ terms.hashtag }}</strong> es una iniciativa de
  <strong>{{ terms.clientName }}</strong>, persona jurídica
  <span v-if="containClientCity"> con sede en la ciudad de {{ terms.clientCity }}</span>
  <span v-else-if="containClientAddress"> con sede en {{ terms.clientAddress }},</span>
  inscrita con el {{ clientDocumentLabel }} nº {{ terms.clientCNPJ }} (“{{ terms.clientNickname }}”) y de
  <strong>FANBASE NETWORK TECNOLOGÍA Y SERVICIOS S.A.</strong>, persona jurídica
  con sede en la ciudad de Campinas - SP, inscrita en el CNPJ bajo el nº
  41.835.006/0001-66 ("FANBASE"), en adelante {{ terms.clientNickname }} y FANBASE en conjunto
  (“PARTES”).
</p>
<p>
  Las PARTES consideran relevantes los registros electrónicos y datos personales
  proporcionados por usted (“Usuario”) en la utilización del sitio
  <strong>{{ terms.hashtag }}</strong>, disponible a través del enlace:
  <a :href="terms.url" target="_blank">{{ terms.url }}</a>
  (“Sitio”), sirviendo la presente Política de Privacidad ("Política") para
  regular, de forma simple, transparente y objetiva, qué datos e informaciones
  serán obtenidos, así como cuándo los mismos podrán ser utilizados por las
  PARTES.
</p>
<p>
  <strong>Agente de tratamiento:</strong> Fanbase Network Tecnología y Servicios
  S.A., persona jurídica con sede en la ciudad de Campinas, inscrita en el CNPJ bajo el nº
  41.835.006/0001-66 ("Fanbase")
</p>
<p><strong>Rol en el tratamiento:</strong> Operador</p>
<p>
  <strong>Naturaleza de los datos tratados:</strong> Datos personales proporcionados por
  el usuario y/o recolectados automáticamente.
</p>
<p>
  <strong>Finalidad del uso de los datos:</strong> Utilizar datos personales
  con el fin de viabilizar la participación en campañas y proyectos de
  relacionamiento de las <strong>PARTES</strong>, así como para eventual contacto
  con los Usuarios durante la participación en la encuesta.
</p>
<p><strong>Base legal:</strong> Consentimiento del titular.</p>
<p>
  <strong>Compartición:</strong> Operadores y proveedores de servicios
  esenciales para la ejecución de campañas y programas de relacionamiento de las
  PARTES.
</p>
<p>
  <strong>Protección de Datos:</strong> Medidas de seguridad, técnicas y
  administrativas adecuadas.
</p>
<p>
  <strong>Sus derechos: </strong> Confirmación de la existencia de tratamiento,
  acceso, corrección, etc.
</p>
<p>
  Esta Política podrá ser actualizada en cualquier momento por las
  <strong>PARTES</strong>, mediante aviso en el sitio y/o por correo electrónico, si el Usuario
  ha optado por recibir comunicaciones de las <strong>PARTES</strong>.
</p>

<h3>I. QUÉ DATOS UTILIZAMOS</h3>
<p>
  Las PARTES podrán recopilar la información introducida activamente por el Usuario en
  el momento del registro y de la encuesta y, además, información recopilada
  automáticamente durante el uso del Sitio <strong>{{ terms.hashtag }}</strong> y de la red,
  como, por ejemplo, identificación del establecimiento comercial utilizado, IP
  con fecha y hora de la conexión, entre otros.
</p>
<p>
  Existe, por tanto, el tratamiento de dos tipos de datos personales: (i) aquellos
  proporcionados por el propio Usuario; y (ii) aquellos recopilados automáticamente.
</p>

<p>
  (i) Información proporcionada por el Usuario: <strong>FANBASE</strong> recopila
  toda la información introducida activamente por el Usuario en el Sitio
  <strong>{{ terms.hashtag }}</strong>, al momento de completar el registro para
  posibilitar la participación en las campañas de las <strong>PARTES</strong>,
  en los términos de uso disponibles en
  <a :href="terms.url" target="_blank">{{ terms.url }}</a>.
  Las PARTES utilizarán dicha información para comunicarse con el Usuario
  durante su participación en la(s) campaña(s) y programas de relacionamiento.
</p>

<p>
  (ii) Datos recopilados automáticamente: <strong>FANBASE</strong> también recopila
  una serie de informaciones de forma automática, tales como: características del
  dispositivo de acceso, {{pronoun}} navegador, IP (con fecha y hora), origen del IP,
  información sobre clics, páginas visitadas, las páginas siguientes visitadas
  después de salir del Sitio, o cualquier término de búsqueda introducido en los
  sitios o en referencia a estos, entre otros. Para dicha recopilación,
  <strong>FANBASE</strong> utilizará algunas tecnologías estándar, como cookies,
  pixel tags, beacons, local shared objects y otras tecnologías que se utilizan
  con el propósito de mejorar la experiencia de navegación del Usuario en el
  Sitio, de acuerdo con sus hábitos y preferencias.
</p>

<p>
  Es posible deshabilitar, a través de la configuración de su navegador de
  internet, la recopilación automática de información mediante algunas tecnologías,
  como cookies y caché, así como en nuestro propio sitio web, específicamente
  en relación con los cookies. Sin embargo, el Usuario debe ser consciente de que,
  si se deshabilitan estas tecnologías, algunos recursos ofrecidos por el sitio,
  que dependen del tratamiento de dichos datos, pueden no funcionar correctamente.
</p>

<p>
  La información recopilada podrá ser compartida por las PARTES con: (i) otras
  empresas asociadas, cuando sea necesario para la adecuada prestación de los
  servicios objeto de sus actividades; (ii) para la protección de los intereses de
  las PARTES en cualquier tipo de conflicto; (iii) mediante decisión judicial o
  requerimiento de autoridad competente.
</p>

<p>
  Asimismo, aclaramos que su información también podrá ser compartida con
  empresas proveedoras de infraestructura tecnológica y operativa necesaria
  para las actividades de <strong>FANBASE</strong>, como proveedores de servicios
  de almacenamiento de información.
</p>

<p>
  El Usuario podrá acceder, actualizar y añadir sus datos, así como podrá solicitar
  la eliminación de sus datos recopilados por las PARTES, accediendo al sitio
  <a :href="terms.url" target="_blank">{{ terms.url }}</a>
  e ingresando los datos de su CPF para editar sus respuestas previamente
  registradas o solicitar la eliminación a través del correo electrónico
  <a href="mailto:excluir@fanbase.com.br">excluir@fanbase.com.br</a>. Haremos
  nuestro mejor esfuerzo para responder en el menor tiempo posible, respetando
  los plazos de conservación establecidos por la legislación.
</p>

<h3>II. CÓMO UTILIZAMOS LOS DATOS</h3>
<p>
  La información recopilada por las PARTES tiene como finalidad posibilitar la
  participación de los Usuarios en las campañas del programa
  <strong>{{ terms.hashtag }}</strong> y en los programas de relacionamiento de las PARTES.
</p>

<p>
  La información recopilada podrá, además, ser utilizada con fines publicitarios,
  como el envío de información sobre marcas, productos, promociones y descuentos
  de las PARTES o de sus socios, así como la divulgación de eventos y programas
  de fidelización, o para la realización de encuestas de satisfacción, mediante
  el consentimiento del Usuario para dicha finalidad.
</p>

<p>
  En caso de que no desee recibir más comunicaciones institucionales de
  <strong>{{ terms.hashtag }}</strong>, el Usuario puede en cualquier momento
  contactar a las PARTES a través del formulario disponible en
  <a :href="terms.url" target="_blank">{{ terms.url }}</a>
</p>

<p>
  Base legal: En estos casos, el tratamiento de datos está autorizado por el inciso I
  del artículo 7º de la Ley nº 13.709/2018, la Ley General de Protección de Datos
  (“Ley General de Protección de Datos – LGPD”).
</p>

<h3>III. CÓMO UTILIZAMOS LOS COOKIES</h3>
<p>
  Los cookies son archivos o informaciones que pueden almacenarse en sus
  dispositivos cuando usted visita el Sitio <strong>{{ terms.hashtag }}</strong>.
  Generalmente, un cookie contiene el nombre del sitio que lo originó, su tiempo
  de vida y un valor, que se genera aleatoriamente.
</p>

<p>
  Utilizamos cookies para facilitar el uso y adaptar mejor el Sitio a sus
  intereses y necesidades, así como para recopilar información sobre el uso de
  nuestros sitios y servicios, ayudando a mejorar sus estructuras y contenidos.
  Los cookies también pueden utilizarse para acelerar sus actividades y
  experiencias futuras en el Sitio.
</p>

<h4>TIPOS DE COOKIES</h4>
<p>
  Necesarios: Estos cookies son esenciales para que el Sitio cargue correctamente y permiten que usted navegue en nuestros sitios y utilice todas las funcionalidades.
</p>
<p>
  Rendimiento: Estos cookies nos ayudan a entender cómo los visitantes interactúan con el Sitio, proporcionando información sobre las áreas visitadas, el tiempo de permanencia en el sitio y cualquier problema encontrado, como mensajes de error.
</p>
<p>
  Funcionales: Estos cookies permiten que el Sitio recuerde sus elecciones, para proporcionar una experiencia más personalizada. También permiten que los Usuarios vean videos y utilicen herramientas sociales, campos para comentarios, foros, entre otros.
</p>
<p>
  Marketing: Estos cookies se utilizan para proporcionar contenido más relevante y de interés para los Usuarios. Pueden ser utilizados para mostrar publicidad más dirigida o limitar la cantidad de veces que se muestra en el Sitio. También permiten medir la eficacia de una campaña publicitaria de las <strong>PARTES</strong>.
</p>
<p>
  Después de que el Usuario consienta el uso de cookies al utilizar el Sitio
  <strong>{{ terms.hashtag }}</strong>, FANBASE almacenará un cookie en su dispositivo para recordarlo en la próxima sesión.
</p>
<p>
  En cualquier momento, el Usuario podrá revocar su consentimiento respecto a los cookies, para lo cual deberá eliminar los cookies del Sitio
  <strong>{{ terms.hashtag }}</strong> utilizando la configuración de su navegador preferido. Para más información sobre cómo gestionar los cookies en los navegadores:
</p>
<p>
  Internet Explorer: <br/>
  <a href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank">
    https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies
  </a>
</p>
<p>
  Mozilla Firefox: <br/>
  <a href="https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam" target="_blank">
    https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam
  </a>
</p>
<p>
  Google Chrome: <br/>
  <a href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR" target="_blank">
    https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR
  </a>
</p>
<p>
  Safari: <br/>
  <a href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac" target="_blank">
    https://support.apple.com/pt-br/guide/safari/sfri11471/mac
  </a>
</p>
<p>
  Por último, recordamos que, en caso de que el Usuario no acepte algunos cookies del Sitio
  {{ terms.hashtag }}, ciertos servicios pueden no funcionar de manera ideal.
</p>

<h3>IV. CON QUIÉN COMPARTIREMOS LOS DATOS</h3>
<p>
  Las PARTES constituyen grupos económicos que trabajan en asociación con diversas empresas. De este modo, podrán compartir la información recopilada a través del Sitio en los siguientes casos:
</p>
<p>
  ii. Con otras empresas de sus Grupos Económicos, constituidas o que operen en cualquier país, que se comprometen a utilizar la información para los mismos fines indicados en la presente Política;
</p>
<p>
  iii. Con empresas asociadas, en el desarrollo de las actividades comerciales y campañas de marketing de las PARTES;
</p>
<p>
  iv. Para la protección de los intereses de las PARTES en cualquier tipo de conflicto, incluyendo acciones judiciales;
</p>
<p>
  v. En caso de transacciones y cambios societarios que involucren a las PARTES, situación en la que la transferencia de la información será necesaria para la continuidad de los servicios; o,
</p>
<p>
  vi. Mediante orden judicial o requerimiento de autoridades administrativas con competencia legal para ello.
</p>

<h3>V. CÓMO MANTENEMOS LOS DATOS SEGUROS</h3>
<p>
  Las PARTES almacenarán la información recopilada en su Sitio en servidores propios o contratados.
</p>
<p>
  <strong>FANBASE</strong> utiliza medios razonables de mercado y legalmente exigidos para preservar la privacidad de los datos recopilados en su Sitio. De esta forma, adopta las siguientes precauciones, en cumplimiento de las directrices de seguridad establecidas en el Decreto nº 8.771/2016, tales como:
</p>
<p>
  i. FANBASE utiliza métodos estándar y de mercado para cifrar y anonimizar los datos recopilados;
</p>
<p>
  ii. FANBASE cuenta con protección contra accesos no autorizados a sus sistemas;
</p>
<p>
  iii. FANBASE solo autoriza el acceso de personas previamente definidas al lugar donde se almacenan las informaciones recopiladas;
</p>
<p>
  iv. Aquellos que tengan acceso a la información deberán comprometerse a mantener absoluta confidencialidad. El incumplimiento de esta obligación generará responsabilidad civil conforme a la legislación brasileña; y
</p>
<p>
  v. Mantenimiento de un registro que indique el momento, duración, identidad del empleado o responsable del acceso y el archivo accedido, conforme al artículo 13 del Decreto nº 8.771/2016.
</p>
<p>
  Las PARTES realizan sus mejores esfuerzos para preservar la privacidad de los datos de los Usuarios. Sin embargo, ningún sitio es totalmente seguro y las PARTES no pueden garantizar plenamente que toda la información que circula en el Sitio no sea objeto de accesos no autorizados. Por este motivo, recomendamos a los Usuarios tomar medidas adecuadas para protegerse, como mantener confidenciales sus nombres de usuario y contraseñas.
</p>

<h3>VI. RETENCIÓN DE LA INFORMACIÓN RECOPILADA</h3>
<p>
  La información recopilada por <strong>FANBASE</strong> a través del Sitio será eliminada automáticamente de sus servidores cuando deje de ser útil para los fines para los cuales fue recopilada, conforme a los términos de uso del
  <strong>{{ terms.hashtag }}</strong>, o cuando el Usuario solicite la eliminación de sus datos personales.
</p>
<p>
  Sin perjuicio de lo anterior, la información podrá conservarse para el cumplimiento de obligaciones legales o regulatorias, transferencia a terceros — siempre respetando los requisitos de tratamiento de datos — y uso exclusivo de las <strong>PARTES</strong>, quedando prohibido su acceso por terceros, siempre que esté anonimizada.
</p>

<h3>VII. SUS DERECHOS</h3>
<p>
  En cumplimiento de la normativa aplicable en materia de tratamiento de datos personales, las PARTES respetan y garantizan al Usuario la posibilidad de presentar solicitudes basadas en los siguientes derechos:
</p>
<p><strong>i)</strong> confirmación de la existencia de tratamiento;</p>
<p><strong>ii)</strong> acceso a los datos;</p>
<p>
  <strong>iii)</strong> corrección de datos incompletos, inexactos o desactualizados;
</p>
<p>
  <strong>iv)</strong> anonimización, bloqueo o eliminación de datos innecesarios, excesivos o tratados en incumplimiento;
</p>
<p>
  <strong>v)</strong> portabilidad de sus datos a otro proveedor de servicio o producto, mediante solicitud expresa del Usuario;
</p>
<p>
  <strong>vi)</strong> eliminación de los datos tratados con el consentimiento del Usuario;
</p>
<p>
  <strong>vii)</strong> obtención de información sobre las entidades públicas o privadas con las cuales las PARTES compartieron sus datos;
</p>
<p>
  <strong>viii)</strong> información sobre la posibilidad de no otorgar su consentimiento, así como sobre las consecuencias en caso de negativa;
</p>
<p><strong>ix)</strong> revocación del consentimiento.</p>

<p>
  Parte de estos derechos podrá ser ejercida directamente por el Usuario a través de la gestión de la información de su cuenta, mientras que otros dependerán del envío de una solicitud para su posterior evaluación y adopción de medidas por parte de las PARTES.
</p>
<p>
  En caso de necesitar ayuda para ejercer sus derechos, el Usuario puede ponerse en contacto con las PARTES conforme a lo indicado en esta Política.
</p>
<p>
  El Usuario reconoce que la eliminación de la información esencial para la gestión de su cuenta en FANBASE implicará la cancelación de su registro, con la consecuente finalización de los servicios prestados y de su participación en cualquier promoción en la que esté inscrito.
</p>
<p>
  FANBASE realizará todos los esfuerzos posibles para atender dichas solicitudes en el menor tiempo posible. No obstante, incluso en caso de solicitud de eliminación, se respetará el plazo mínimo de conservación de la información de los usuarios de aplicaciones de Internet, conforme a la legislación brasileña.
</p>

<h3>VIII. LEGISLACIÓN Y JURISDICCIÓN</h3>
<p>
  Esta Política se regirá, interpretará y ejecutará de acuerdo con las leyes de la República Federativa de Brasil, especialmente la Ley nº 13.709/2018, independientemente de las leyes de otros estados o países, siendo competente la jurisdicción del domicilio del Usuario para resolver cualquier controversia derivada de este documento.
</p>
<p>
  FANBASE es la operadora de los datos, y todas las comunicaciones al responsable del tratamiento deben dirigirse al correo electrónico
  <a href="mailto:privacidade@fanbase.com.br.">privacidade@fanbase.com.br.</a>.
</p>
<p>Actualizado el 19 de marzo de 2026.</p>

      </div>
    </vs-row>
  </div>

</template>

<script>

export default {
  name: 'TermosDefault',
  computed: {
    terms() {
      return this.$store.state.template.terms
    },
    clientDocumentLabel() {
      const iso3 = this.$store.state.template &&
        this.$store.state.template.survey &&
        this.$store.state.template.survey.iso3
          ? String(this.$store.state.template.survey.iso3).toUpperCase()
          : ''

      if (iso3 === 'COL') return 'NIT'
      if (iso3 === 'PER') return 'RUC'
      return 'Número de identificación tributaria'
    },
    genderuppercase(){
      let gender = this.$store.state.template.nouns;
      if(gender.gender == "1"){
        return 'La'
      }
      else if(gender.gender == "0"){
        return 'El'
      }
    },
    genderlowercase(){
      let gender = this.$store.state.template.nouns;
      if(gender.gender == "1"){
        return 'e la'
      }
      else if(gender.gender == "0"){
        return 'el'
      }
    },
    pronoun(){
      let gender = this.$store.state.template.nouns;
      if(gender.gender == "1"){
        return 'da'
      }
      else if(gender.gender == "0"){
        return 'do'
      }
      else{
        return 'do'
      }
    },
    containClientAddress () {
      return (this.terms && this.terms.clientAddress)
    },
    containClientCity () {
      return (this.terms && this.terms.clientCity)
     }
  }
}


</script>

<style scoped>
</style>